import React, { useEffect, useState, useRef } from "react";
import "./UsesOfQrCodes.scss";
import LazyLoad from "react-lazyload";
import { useSwipeable } from "react-swipeable";
import Card from "./cards/Card";

import { FormattedMessage } from "react-intl";

function UsesOfQrCodes({
  setPartOfVideo1,
  partOfVideo1,
  resetAnimation,
  currentLocale,
  timeoutId,
}) {
  const barRef = useRef();
  const handlers = useSwipeable({
    onSwipedLeft: (eventData) => {
      setPartOfVideo1((prev) => prev + 1);
      resetAnimation(partOfVideo1 + 1, 1);
    },
    onSwipedRight: (eventData) => {
      setPartOfVideo1((prev) => prev - 1);
      resetAnimation(partOfVideo1 - 1, 1);
    },
  });
  const qrCodeInfo = {
    labels: {
      cs: [
        "1. Zvýšení návštěvnosti na webu",
        "2. Získání nových spojení na socialních sítích",
        "3. Snadné připojení k vaší wifi",
        "4. Snadné předání vašich kontaktních informací",
        "5. Zákaznický průzkum nebo získání zpětné vazby",
        "6. Snadné nalezení vaší prodejny nebo kanceláře",
        "7. Předání informaci o produktu, osobě nebo místu",
        "8. QR platby pomocí mobilního telefonu",
      ],
      en: [
        "1. Get more traffic to your website",
        "2. Get more connections on social media pages",
        "3. Connect to a wifi network easily",
        "4. Share your contact details instantly",
        "5. Run a survey and get feedback or product reviews",
        "6. Navigate people directly to your store or office",
        "7. Provide more information about a person, place, or product",
        "8. Make or accept mobile payments",
      ],
    },
    texts: {
      cs: [
        "QR kód odkáže uživatele během chvilky na váš web, eshop nebo konkretní produktovou stránku",
        "Vložte do QR kódu jednu nebo více sociálních sítí a usnadněte ostatním zůstat ve spojení",
        "Snadné připojení k wifi, bez nutnosti zadávat přihlašovací údaje, heslo a podobně.",
        "Okamžité uložení vybraných kontaktních údajů do telefonu, bez složitého přepisování a chyb",
        "Vytvoření digitálního dotazníku, zpracování a analýza získaných dat je otázkou chvilky",
        "Snadná lokalizace v husté městské zástavbě, odlehlé části města bez č.p. nebo v prům. areálu",
        "Pokud prostor nebo estetika nedovoluje vepsat více, QR kód odkáže uživatele na doplňující info",
        "Bezpečný bankovní převod nebo platba kryptoměnou bez složitého vypisování čísel",
      ],
      en: [
        "Especially in the print media it is handy to guide readers to your web, eshop or product page",
        "Refer one or more social media in a QR code. Let users stay in touch and grow your audience.",
        "Super-fast connection to wifi. Without entering or remembering login data and password.",
        "Safely save a contact data in your phone. Without any manual re-writing and errors.",
        "Create a digital survey. Processing and analyzing collected data is matter of minutes.",
        "Precisely locate a place in densely populated city centers, remote destinations, or industrial areas.",
        "If space, aesthetics or poor readability limits you in providing information, QR code will help.",
        "Safe bank transfer or cryptocurrency payment. No manually entered data, no errors. Just 1 scan",
      ],
    },
    moreInfo: {
      cs: [
        'QR kód zvládne jakýkoliv odkaz. Náš multi-datový QR kód umožňuje vložit více odkazů do jednoho stylového QR kódu a vše si jednoduše přizpůsobit pomocí našeho editoru. Můžete tak vytvořit malé webové stránky s vaším obsahem. Proč si nezvýšit návštěvnost použitím QR kódu se speciálni slevou, nabídkou souvisejících produktů nebo jen odkazem na váš web. Jeho správným umístěním umožňíte zákazníkům nakupovat v nových situacích, např. při používání produktu, čtení propagačních materiálů nebo když jsou poblíž prodejny. Nabízíme pokročilé analytické nástroje umožňující měřit počet skenovani a tím i úspěšnost vaší kampaně.',
        'QR kódy propojují fyzický svět s vašimi online kanály a vytváří příjemný uživatelský zážitek. Jejich umístěním na balení produktu, tiskovinách nebo libovolném předmětu ve formě samolepky můžete snadno vytvořit vstupní bránu k vašim sociálním sítím jako Facebook, Instagram, Twitter, LinkedIn a dalším. QR kód může obsahovat jednu nebo více sociálních sítí, pomáhá zaujmout a budovat vaše publikum. Vyzkoušejte náš multi-data QR kód, kde můžete vyplnit všechny vaše sociální účty, nastavit si vzhled a uživatelům dát možnost volby. QR kód nazvaný digitální vizitka může navíc zobrazovat i vaše kontaktní informace nebo fotografii.',
        'Svět je stále více závislý na internetu a je nepřehlédnutelným trendem, že hosté okamžitě žádají o Wi-fi připojení v hotelech, restauracích, turistických atrakcích a na mnoha dalších veřejných či soukromých místech. Poskytnutí našeho wifi QR kódu je skvělý způsob, jak učinit váš domov, firmu a komerční zařízení pohodlný a efektivní pro vaše přátele, rodinu nebo zákazníky, pokud podnikáte. Jedno jednoduché naskenování wifi QR kódu a jste připojeni. Bezproblémové a rychlé. Není potřeba zadávat žádné přihlašovací údaje ani heslo a podobně.',
        'Zadejte všechny své kontaktní údaje do jednoho QR kódu nazvaného vizitka. Vaši přátelé nebo zákazníci je mohou snadno uložit do svého zařízení jedním naskenováním. Bezpečný, rychlý a offline způsob sdílení vašeho kontaktu. Žádné chyby a ruční zadávání dat. Můžete také použít náš QR kód nazvaný digitální vizitka a vytvořit tak překrásný mikro web s vašimi kontaktními údaji dostupnými všem, kteří naskenovali QR kód. Mikro web je přizpůsobitelný, může zobrazit vaši fotografii nebo logo, sociální sítě a uložit kontakt do telefonu uživatele jedním kliknutím. Ideální pro vizitky nebo tisková média.',
        'QR kódy pomáhají získávat veřejné zákaznické recenze na Google, Trip Advisor nebo dalších platformách. Můžete také získávat zpětnou vazbu pro své interní účely prostřednictvím našeho feedback QR kódu nebo i standardních Google formulářů. Nejjednodušší a nejúčinnější způsob, jak zajistit uživatelům skvělý zážitek a vytvořit obousměrný komunikační kanál nezbytný pro posílení vztahů se zákazníky a zlepšení vašich produktů nebo služeb. Umístěte QR kód na baleni produktu, děkovnou kartu zaslanou s produktem nebo někde ve vašem obchodě a dejte zákazníkům vědět, že o ně pečujete a na jejich názoru záleží.',
        'V hustě obydlených městských centrech nebo průmyslových areálech může být obtížné najít váš obchod, dílnu nebo kancelář. Totéž pro venkov nebo odlehlá místa bez adresy. Náš geo lokační QR kód pracuje se souřadnicemi (zeměpisná šířka a délka). Dokáže velmi přesně navést vaše návštěvníky na požadované místo, i když je uprostřed lesa a lze jej přečíst všemi současnými navigačními aplikacemi. Už žádné hledání a vysvětlování správné cesty. Můžete také použít náš adresový QR kód, který navede návštěvníka na požadovanou adresu, aniž by musel napsat jediné písmeno. Stačí jedno skenování a navigace se spustí automaticky.',
        'QR kódy jsou vstupní bránou k jakékoli informaci – ať už jde o text, obrázek, video nebo cokoliv jiného. Můžete také propojit vaše publikum s veškerým vaším obsahem pomocí jediného multi-data QR kódu a pomocí našeho jednoduchého editoru zobrazit a spravovat váš obsah na krásnem mikro webu. Použijte náš info QR kód ke sdílení dodatečných informací, zobrazení obrázkové galerie a navedení uživatele k požadované akci – ke koupi produktu, stažení návodu nebo jiného souboru, k návštěvě webové stránky atd. Věděli jste, že 2/3 spotřebitelů preferují sledování videa o produktu těsně před jeho nákupem?',
        'Snadno přijímejte platby – spropitné nebo dary pro vaše projekty. Nechte své fanoušky a sledující podpořit vaši vášen. Vytvořte si QR kód bankovní platby a nechte uživatele platit bankovním převodem. Tyto QR kódy jsou velmi často užívány na fakturách, protože uživatelé tak nemusí zadávat žádná data ručně, stačí naskenovat QR kód ve své bankovní aplikaci. Vytvoření QR kódu krypto peněženky umožňuje vašim přátelům, rodině nebo zákazníkům platit jakoukoli kryptoměnou přímo na váš účet. Můžete jich mít kolik chcete.'
      ],
      en: [
        'QR code may direct people to any link. Our multi-data QR code allows you to insert multiple links in one beautiful QR code and effortlessly manage them in our simple drag-and-drop editor. You can create fully customized landing page with your linked content. Why not to support your web traffic by using a QR code linked to a special offer, related product or your website. Right placement will allow your customers to shop in a new situations – when using a product, reading company prints or when they are near your store. Our advanced analytics you can track number of scans and measure success ratio of your campaign.',
        'QR codes connect the offline experience to your online channels and gamify the user experience. By placing them on product package, print media or basically any physical object in form of sticker, you easily create a new gateway to your social media pages - Facebook, Instagram, Twitter, LinkedIn or others. QR code can contain one or more social accounts helping you to build and engage your audience. Use our multi-data QR code to fill all your social accounts, set the right look and let users choose. Moreover our digital vCard QR code can also show your contact information including a photo and option to save the contact.',
        'The world has become increasingly dependent on internet and it is notable trend for guests to immediately ask for Wi-fi connection in hotels, restaurants, tourist attractions and many other public or private places. Providing our wifi QR code is a great way to make your home, business and commercial establishments smart and efficient for your friends, family or customers if you run a business. One simple scan of the wifi QR code and you are connected. Hassle-free and fast. No searching for wifi network around, no waiting and typing the password.',
        'Input all your contact details in a single vCard QR code. Your friends or customers can easily save them in their device with just a single scan. Secure, fast and offline method to share your contact. No more errors and manual data entering. You can also use our digital vCard QR code creating beautiful landing page with your contact data accessible for all who scanned your QR code. The landing page is customizable, can show your photo or logo, social networks and save the contact in any device with click of a button. Perfect for business cards or any print media.',
        'With QR codes you can collect public customer reviews on Google, Trip advisor or other platforms. You can also privately collect feedback for your internal purposes with our feedback QR code forms or Google forms. The easiest and the most efficient way to ensure a great user experience, forming a two-way communication channel necessary for boosting consumer trust and relationships and improving your products or services. Place feedback QR code directly on your product package, on a thank you card sent with the product or anywhere in your store and let customers know that you care and their opinion matters.',
        'It might be difficult to find your store, workshop or office in heavily populated city centers or big industrial areas. Same for the country-side or secluded locations without address. Our location QR code works with geographic coordinates (latitude and longitude). It can guide your visitors precisely to the desired spot, no matter it is in the middle of the forest and can be read by all current navigation apps. No more searching and explaining the right way. You can also use our address QR code navigating your visitor to the desired address without typing a single letter. Just one scan and navigation starts automatically.',
        'QR codes are a gateway to any information – whether it is a text, picture, video or anything else. You can also connect audience to all of your content with one multi-data QR code and use our simple drag-and-drop editor to effortlessly show your linked content on a beautiful and customized landing page. Use our info-page QR code to share additional information, show a picture gallery and guide the user to the desired action – to buy a product, download a product manual or other file, visit a website etc. Did you know that 2/3 of the consumers prefer watching videos to learn about a product right before buying it?',
        'Collect payments easily - tips for your content or donations for your projects, let your fans and followers support you in monetizing your passions. Create a bank payment QR code and let users pay by a bank transfer. These are very often shown on invoices to make the payment easier. Users don’t need to enter any data manually, just to scan the QR code in their banking app. Creating a crypto wallet QR code allows your friends, family or customers to pay by any cryptocurrency directly to your account. You can have them as many as you wish.'
      ]
    }
  };
  function isMobile() {
    if (window.innerWidth <= 700) {
      return true;
    } else {
      return false;
    }
  }
  return (
    //
    <section {...handlers} id="one-qr-code-lots-of-uses">
      <h2>
        <FormattedMessage id="home.use.h" />
      </h2>
      <div className="wrapper">
        <div
          onMouseEnter={() => {
            if (barRef.current.classList.contains("stopped")) {
              resetAnimation(partOfVideo1, 1);
            }
          }}
          className="left"
        >
          <div
            style={{
              transform: isMobile()
                ? `translateX(-${partOfVideo1 * 50}vw)`
                : "",
            }}
            className="timeline-wrapper vertical"
          >
            <div className="timeline timeline1">
              <div
                ref={barRef}
                className={`bar ${
                  partOfVideo1 === 0
                    ? "part0"
                    : partOfVideo1 === 1
                    ? "part1"
                    : partOfVideo1 === 2
                    ? "part2"
                    : partOfVideo1 === 3
                    ? "part3"
                    : partOfVideo1 === 4
                    ? "part4"
                    : partOfVideo1 === 5
                    ? "part5"
                    : partOfVideo1 === 6
                    ? "part6"
                    : partOfVideo1 === 7
                    ? "part7"
                    : partOfVideo1 === 8
                    ? "part8"
                    : ""
                }`}
              ></div>
              <div
                onClick={() => {
                  resetAnimation(0, 1);
                  setPartOfVideo1(0);
                }}
                className={`point ${partOfVideo1 >= 0 && "active"}`}
              ></div>
              <div
                onClick={() => {
                  resetAnimation(1, 1);
                  setPartOfVideo1(1);
                }}
                className={`point ${partOfVideo1 >= 1 && "active"}`}
              ></div>
              <div
                onClick={() => {
                  resetAnimation(2, 1);
                  setPartOfVideo1(2);
                }}
                className={`point ${partOfVideo1 >= 2 && "active"}`}
              ></div>
              <div
                onClick={() => {
                  resetAnimation(3, 1);
                  setPartOfVideo1(3);
                }}
                className={`point ${partOfVideo1 >= 3 && "active"}`}
              ></div>
              <div
                onClick={() => {
                  resetAnimation(4, 1);
                  setPartOfVideo1(4);
                }}
                className={`point ${partOfVideo1 >= 4 && "active"}`}
              ></div>
              <div
                onClick={() => {
                  resetAnimation(5, 1);
                  setPartOfVideo1(5);
                }}
                className={`point ${partOfVideo1 >= 5 && "active"}`}
              ></div>
              <div
                onClick={() => {
                  resetAnimation(6, 1);
                  setPartOfVideo1(6);
                }}
                className={`point ${partOfVideo1 >= 6 && "active"}`}
              ></div>
              <div
                onClick={() => {
                  resetAnimation(7, 1);
                  setPartOfVideo1(7);
                }}
                className={`point ${partOfVideo1 === 7 && "active"}`}
              ></div>
            </div>
            <div className="texts-wrapper">
              {qrCodeInfo.labels[currentLocale].map((label, index) => (
                <span
                  className={`${partOfVideo1 === index && "active"} label`}
                  onClick={() => {
                    resetAnimation(index, 1);
                    setPartOfVideo1(index);
                  }}
                >
                  <div>{label}</div>
                </span>
              ))}
            </div>
          </div>
        </div>
        <LazyLoad className="cards-wrapper" offset={1000} once>
          <Card
            index={0}
            qrCodeInfo={qrCodeInfo}
            currentLocale={currentLocale}
            partOfVideo1={partOfVideo1}
            resetAnimation={resetAnimation}
            timeoutId={timeoutId}
          />
          <Card
            index={1}
            qrCodeInfo={qrCodeInfo}
            currentLocale={currentLocale}
            partOfVideo1={partOfVideo1}
            resetAnimation={resetAnimation}
            timeoutId={timeoutId}
          />
          <Card
            index={2}
            qrCodeInfo={qrCodeInfo}
            currentLocale={currentLocale}
            partOfVideo1={partOfVideo1}
            resetAnimation={resetAnimation}
            timeoutId={timeoutId}
          />
          <Card
            index={3}
            qrCodeInfo={qrCodeInfo}
            currentLocale={currentLocale}
            partOfVideo1={partOfVideo1}
            resetAnimation={resetAnimation}
            timeoutId={timeoutId}
          />
          <Card
            index={4}
            qrCodeInfo={qrCodeInfo}
            currentLocale={currentLocale}
            partOfVideo1={partOfVideo1}
            resetAnimation={resetAnimation}
            timeoutId={timeoutId}
          />
          <Card
            index={5}
            qrCodeInfo={qrCodeInfo}
            currentLocale={currentLocale}
            partOfVideo1={partOfVideo1}
            resetAnimation={resetAnimation}
            timeoutId={timeoutId}
          />
          <Card
            index={6}
            qrCodeInfo={qrCodeInfo}
            currentLocale={currentLocale}
            partOfVideo1={partOfVideo1}
            resetAnimation={resetAnimation}
            timeoutId={timeoutId}
          />
          <Card
            index={7}
            qrCodeInfo={qrCodeInfo}
            currentLocale={currentLocale}
            partOfVideo1={partOfVideo1}
            resetAnimation={resetAnimation}
            timeoutId={timeoutId}
          />
        </LazyLoad>
      </div>
    </section>
  );
}

export default UsesOfQrCodes;
